"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.actions.run': 'Uruchom Test',
    'botTest.actions.results': 'Zobacz Wyniki',
};
